module.exports = "/_next/static/images/EmptyVoucher-94b22168d155a9576fd7ebefbfb48316.svg";